<template>
<div>
    <navi selectedid="tlService"></navi>
    <subNavi selectedid="tlDownload" lastrouter="/service/warranty" nextrouter="/service/knowledge"></subNavi>
    
    <div id="Contents">
        <!-- <div id="Logo">
            <h1 title="Arivo Tyre"><img src="../../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42"></h1>
            <h2 title="HOME"><a href="../index.html" title="HOME"><img src="../../common/images/top/home.png" alt="HOME" width="229" height="219"></a></h2>

            <siteMenu></siteMenu>
        </div> -->
        <logo selectedid="tlService"></logo>

        <spNavi selectedid="tlDownload"></spNavi>

        <div id="Main">
            <div class="company-article">
                <h2 title="Download">Download</h2>
                <dl v-for="item in files">
                <dd><a :href="item.file" class="link-white" type="application/pdf">{{item.title}}</a></dd>
                </dl>
            </div>

            <share></share>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>
import Navi from "components/common/navi";
import SubNavi from "components/service/subnavi";
import Logo from "components/common/logo";
import SpNavi from "components/service/spnavi";
import Share from "components/common/share";
import WebFooter from "components/common/footer";
import downloadApi from "../../api/download-api";
export default {
  name: "Download",
  components: {
    Navi,
    SubNavi,
    Logo,
    SpNavi,
    Share,
    WebFooter
  },
  data() {
    return {
      files: []
    };
  },
  mounted: function() {
      this.getDownloads()
  },
  methods: {
    getDownloads() {
      let _this = this;
      downloadApi.getDownloads(
        function(response) {
          _this.files = response;
        },
        function(error) {
          console.error(error);
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/service/download.vue